export default __webpack_public_path__ + "static/300x169-dade2f96917f124c36ad9834dfef6985.jpg";